import logger from '@/utils/logger'

/**
 * Грузит картинку в кэш браузера, чтобы <img> не всплывал после отрисовки.
 */
export function preloadImage(url) {
  if (!url || typeof window === 'undefined' || typeof Image === 'undefined') {
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    try {
      const img = new Image()
      img.onload = () => resolve()
      img.onerror = () => resolve()
      img.src = url
    } catch (error) {
      logger.error('Ошибка предзагрузки изображения', error)
      resolve()
    }
  })
}
